export const Team = [
  {
    index: 1,
    testimonial:
      "After joining Eden Indigenous Seed Farm, I learned how to save seeds and manage a kitchen garden. Now my family eats healthier and I earn extra from selling indigenous vegetables.",
    user: "/images/farmer-alice-wanjiru.jpeg",
    username: "Alice Wanjiru",
    rating: 4.5,
  },
  {
    index: 2,
    testimonial:
      "Our CBO has revived traditional crops like millet and cowpeas thanks to the seed regeneration program. We now feel more food-secure and connected to our heritage.",
    user: "/images/farmer-francis-ngugi.jpeg",
    username: "Francis Ngugi",
    rating: 4.5,
  },
  {
    index: 3,
    testimonial:
      "Through Eden Indigenous Seed Farms, I learned to make my own biopesticides and biofertilizers using local resources. My soil is healthier, my yields have improved, and I farm more sustainably with lower costs.",
    user: "/images/farmer-nancy-nyambura.jpeg",
    username: "Nancy Nyambura",
    rating: 4.5,
  },
  {
    index: 4,
    testimonial:
      "Thanks to Eden Indigenous Seed Farms, I now access reliable organic markets for my produce. I earn better prices, my customers trust the quality, and I’m proud to sell food grown naturally and sustainably",
    user: "/images/farmer-ruth-waithera.jpeg",
    username: "Ruth Waithera",
    rating: 4.5,
  }
];
